// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"PrimaryButton_PrimaryButton__VbVWN","PrimaryButton--rounded":"PrimaryButton_PrimaryButton--rounded__1B5Dn"};